// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/button/index.css
// module id = 64
// module chunks = 1 2 6